@import (reference) '../../../../../constants/spacing.module.less';

.container {
  padding: @space-16;
}

.header {
  margin-bottom: @space-16;
  justify-content: space-between;
  gap: @space-12;
}

.header-title {
  flex: 1;
}

.table-wrapper {
  margin-bottom: @space-12;
}

.table {
  width: 100%;
}

.empty-row-text {
  padding: @space-32;
  color: var(--grey-600);
  text-align: center;
}

.footer {
  color: var(--grey-600);
  font-size: 14px;
}
